import React, { Component, Fragment } from "react";

import { makeAsRead } from "../../../services/notification";
import ChoosePlan from "./ChoosePlan";
import AppContext from "../../../contexts/AppContext";
import Pay from "./Pay";

import { create as addCard } from "../../../services/card";
import Card from "./Card";
import PaymentCompleted from "./PaymentCompleted";
export class Connect extends Component {
    state = {
        showChooseModal: false
    };

    toggleChooseModal = () => {
        this.setState({ showChooseModal: !this.state.showChooseModal });
    };

    showNotification = () => {
        this.setState({
            unread: 0
        });
        makeAsRead(this.context.state.lastNotification);
        this.context.state.showNotification();
    };

    hideAll = () => {
        this.setState({
            needPayment: false,
            needCard: false,
            showChooseModal: false,
            paymentCompleted: false
        });
    };

    showAddCard = () => {
        this.setState({
            needPayment: false,
            needCard: true
        });
    };
    showPaymentSuccess = () => {
        this.context.state.updateUser();
        this.setState({
            needPayment: false,
            needCard: false,
            paymentCompleted: true
        });
    };

    showPay = plan => {
        this.context.state.chooseConnectsPlan(plan);

        this.setState({
            needPayment: true,
            needCard: false
        });
    };
    addCard = item => {
        return addCard(item).then(response => {
            this.setState({
                needPayment: true,
                needCard: false
            });
        });
    };
    render() {
        return (
            <Fragment>
                {this.state.showChooseModal ? (
                    <ChoosePlan
                        showPay={this.showPay}
                        hideModal={this.hideAll}
                    ></ChoosePlan>
                ) : null}

                {this.state.needCard === true ? (
                    <Card hideCard={this.hideAll} addCard={this.addCard}></Card>
                ) : null}

                {this.state.needPayment === true ? (
                    <Pay
                        item={this.state.item}
                        showAddCard={this.showAddCard}
                        showPaymentSuccess={this.showPaymentSuccess}
                        hidePay={this.hideAll}
                    ></Pay>
                ) : null}

                {this.state.paymentCompleted === true ? (
                    <PaymentCompleted hidePay={this.hideAll}></PaymentCompleted>
                ) : null}

                <div className="position-relative d-inline-block dropdown">
                    <a
                        className="nav-link dropdown-toggler-connects"
                        id="dropdownNotification"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span className="fe fe-send connectsCounts">
                            <span className="badge badge-primary noteCount">
                                {this.context.state.user.balance}
                            </span>
                        </span>
                    </a>
                    <div
                        className="dropdown-menu hide connects dropdown-menu-right"
                        aria-labelledby="dropdownNotification"
                    >
                        <div
                            id="ContentDropDown"
                            className="list-group list-group-flush px-4"
                        >
                            <div className="row">
                                <div className="col-12 ml-n2">
                                    <div className="connects-model-header">
                                        <img
                                            src="/images/buyConnect.png"
                                            alt=""
                                        ></img>
                                    </div>
                                    <h2
                                        className="model-title"
                                        id="model-title"
                                    >
                                        Connects
                                    </h2>
                                    <div className="model-content">
                                        <div
                                            id="model-content"
                                            className=" text-center model-html-container"
                                        >
                                            Connects are used to submit
                                            proposals for jobs. Submitting a
                                            proposal to a job requires up to 1
                                            Connects .
                                        </div>
                                        <hr className="m-4" />
                                        <div
                                            id="model-content"
                                            className=" text-left model-html-container mb-3"
                                        >
                                            Available Connects :{" "}
                                            {this.context.state.user.balance} -{" "}
                                            <a onClick={this.toggleChooseModal}>
                                                buy more
                                            </a>
                                        </div>
                                        <div
                                            className="model-validation-message"
                                            id="model-validation-message"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Connect.contextType = AppContext;
export default Connect;



// WEBPACK FOOTER //
// ./src/components/writer/connects/Connect.js